import request from '../../utils/request'
import config from '../../config/config'

// 获取报名人员列表
export function getEnrollList(data) {
  return request({
    url: config.baseURL + '/api/enroll/list',
    method: 'post',
    data
  })
}

// 获取报名详情
export function getEnrollDetail(data) {
  return request({
    url: config.baseURL + '/api/enroll/detail',
    method: 'post',
    data
  })
}

// 更新报名状态
export function updateEnrollStatus(data) {
  return request({
    url: config.baseURL + '/api/enroll/update',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/enroll/index.js